import { Wrapper, ExitButtonContainer, Modal } from './Modal.style'
import { PropsWithChildren } from 'react'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

interface ModalProps {
  open: boolean
  onClose?: () => void
  displayCloseIcon?: boolean
  disableBackdropClick?: boolean
  idPrefix?: string
}

const Dialog = ({
  open,
  onClose,
  children,
  displayCloseIcon,
  disableBackdropClick,
  idPrefix,
  ...props
}: PropsWithChildren<ModalProps>) => {
  return (
    <Modal
      {...props}
      open={open}
      onClose={(_, reason) => {
        const isBackdropClick = reason === 'backdropClick'
        if (!(isBackdropClick && disableBackdropClick) && onClose) {
          onClose()
        }
      }}
    >
      <Wrapper>
        {displayCloseIcon && (
          <ExitButtonContainer>
            <IconButton id={`${idPrefix}-close-btn`} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </ExitButtonContainer>
        )}
        {children}
      </Wrapper>
    </Modal>
  )
}

export default Dialog
